module.exports = "data:image/png;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJzdGF0aWMvaWNvbnMvbXN0aWxlLTE0NHgxNDQucG5nIjs="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/mstile-144x144.png
// module id = h5tT
// module chunks = 0